import React from 'react'

import { cartProductTotal } from 'lib/cart/decorators/cartProduct'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      cartForm, // via Redux state
      saveCart, // via withStripeEventHandlers
      setCartDate // via Redux actions
    } = props

    const { cartProducts = [] } = cartForm || {}

    // returns true if we should submit this cart product
    const shouldSubmit = cartProduct =>
      cartProduct.id ||
      cartProductTotal(cartProduct) > 0 ||
      (cartProduct.product && cartProduct.location && cartProduct.days > 0)

    // returns a cart product formatted as a SaveCartProductInput type
    const buildCartProductInput = cartProduct => {
      const input = {
        id: cartProduct.id,
        camperId: cartProduct.camper.id,
        productId: cartProduct.product ? cartProduct.product.id : null,
        locationId: cartProduct.location ? cartProduct.location.id : null,
        accountDiscountId: cartProduct.accountDiscount
          ? cartProduct.accountDiscount.id
          : null,
        days: cartProduct.days || 0,
        restrictionsAccepted: !!cartProduct.acknowledgedSoftClose,
        redeemablePasses: cartProduct.redeemablePasses.map(pass => ({
          id: pass.id,
          code: pass.code
        }))
      }

      // Add reservation days if present (for Science Factory locations)
      if (
        cartProduct.reservationDays &&
        cartProduct.reservationDays.length > 0
      ) {
        input.reservationDays = cartProduct.reservationDays.map(
          rd => rd.locationDayId
        )
      }

      return input
    }

    // build graphql mutation variables
    const variables = {
      input: {
        cartProducts: cartProducts
          .filter(shouldSubmit)
          .map(buildCartProductInput)
      }
    }

    const handleClickSave = event => {
      event.preventDefault()

      saveCart({ variables })
    }

    // Handle date selection toggle
    const handleToggleDate = (locationDay, { camper, session }) => {
      setCartDate({ camper, session, locationDay })
    }

    return (
      <WrappedComponent
        onClickSave={handleClickSave}
        onToggleDate={handleToggleDate}
        {...props}
      />
    )
  }
}

export default withEventHandlers
